import { render, staticRenderFns } from "./MarketplaceMain.vue?vue&type=template&id=6abb0ff4&"
import script from "./MarketplaceMain.vue?vue&type=script&lang=js&"
export * from "./MarketplaceMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports